var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6857 28.7501C15.9051 29.1301 16.2207 29.4457 16.6007 29.6651C16.9808 29.8845 17.4119 30 17.8507 30C18.2895 30 18.7206 29.8845 19.1006 29.6651C19.4807 29.4457 19.7963 29.1301 20.0157 28.7501M6.92815 21.6576C6.76486 21.8366 6.65709 22.0591 6.61797 22.2982C6.57885 22.5373 6.61005 22.7826 6.70778 23.0043C6.80552 23.226 6.96557 23.4145 7.16847 23.5469C7.37137 23.6793 7.60838 23.7499 7.85065 23.7501H27.8507C28.093 23.7502 28.33 23.6799 28.5331 23.5477C28.7361 23.4156 28.8964 23.2273 28.9944 23.0057C29.0924 22.7842 29.1239 22.5389 29.085 22.2998C29.0462 22.0607 28.9388 21.838 28.7757 21.6588C27.1132 19.9451 25.3507 18.1238 25.3507 12.5C25.3507 10.5109 24.5606 8.60324 23.154 7.19671C21.7475 5.79018 19.8398 5 17.8507 5C15.8616 5 13.9539 5.79018 12.5474 7.19671C11.1408 8.60324 10.3507 10.5109 10.3507 12.5C10.3507 18.1238 8.58691 19.9451 6.92815 21.6576Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.739d3c4c5d4e26f4019b118a4f4ba4b1.svg";
export { ForwardRef as ReactComponent };